import React, { useContext, useEffect, useState } from "react";
import OverviewTarget from "./modules/overview_target";
import { QueryHomeInfoResult } from "@/api/home/interface";
import { queryHomeInfo } from "@/api/home";
import { Toast } from "@ad/anq-ui";
import AccountInfo from "./modules/account_info";
import Crowd from "./modules/crowd";
import Business from "./modules/business";
import ActivityPromotion from "./modules/activity_promotion";
import MarketInsight from "./modules/market_insight";
import News from "./modules/news";
import Tool from "./modules/tool";
import GlobalContext from "models/globalContext";
import { UserTypeEnum } from "@/api/dmp_common/interface";

const Home = () => {
  const { userType, brandInfoList } = useContext(GlobalContext);
  const [homeInfo, setHomeInfo] = useState<QueryHomeInfoResult>();

  // 无超星星店铺的超级账号，限制其品牌类功能
  const noBrand = userType === UserTypeEnum.BRAND && !brandInfoList?.length;

  useEffect(() => {
    getHomeInfo();
  }, []);

  const getHomeInfo = async () => {
    const res = await queryHomeInfo();

    if (res?.success) {
      setHomeInfo(res.result);
    } else {
      Toast.error(res.errorMsg || "查询首页信息失败");
    }
  };

  return (
    <div className="flex min-w-[calc(1360px+48px)] justify-center p-6 pb-12">
      <div className="w-[1360px] shrink-0">
        <div className="flex">
          <OverviewTarget homeInfo={homeInfo} onRefresh={getHomeInfo} />
          <AccountInfo />
        </div>
        {noBrand ? null : <Crowd />}
        <Business />
        <ActivityPromotion />
        <MarketInsight />
        <div className="mt-4 flex gap-4">
          <div className="w-0 flex-1">
            <News homeInfo={homeInfo} />
          </div>
          <div className="w-0 flex-1">
            <Tool />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
